import { baseApi } from "./baseApi";
import * as API from "@utils/apiPath";
import type {
  TransactionApiResponse,
  TransactionTableFilterParams,
} from "interface/transaction";

const getFormattedParams = (params: TransactionTableFilterParams = {}) => {
  const formatted: Record<string, string | number> = {
    page: params.page ?? 1,
    limit: params.pageSize ?? 10,
  };
  if (params.booking_number) formatted.booking_number = params.booking_number;
  if (params.customer_id) formatted.customer_id = params.customer_id;
  if (params.customer_name) formatted.customer_name = params.customer_name;
  const rawDriver = params.driver_id;
  const driverIdsSerialized =
    Array.isArray(rawDriver)
      ? rawDriver.map(String).map((s) => s.trim()).filter(Boolean).join("-") || undefined
      : typeof rawDriver === "string" && rawDriver.trim()
        ? rawDriver.trim()
        : undefined;
  if (driverIdsSerialized) formatted.driver_id = driverIdsSerialized;
  if (params.booking_status?.length)
    formatted.booking_status = params.booking_status.join("-");
  if (params.payment_status?.length)
    formatted.payment_status = params.payment_status.join("-");
  if (params.payment_method?.length)
    formatted.payment_method = params.payment_method.join("-");
  if (params.createdAt?.[0]) formatted.createdAt = params.createdAt[0];
  if (params.sortField) {
    formatted.sort = params.sortField;
    if (params.sortOrder) {
      formatted.direction = params.sortOrder === "ascend" ? "asc" : "desc";
    }
  }
  return formatted;
};

export const transactionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTransactions: builder.query<
      TransactionApiResponse,
      TransactionTableFilterParams
    >({
      query: (params) => ({
        url: API.GET_TRANSACTION,
        method: "GET",
        params: getFormattedParams(params),
      }),
      providesTags: ["Transaction"],
    }),
    downloadTransactionReport: builder.mutation<
      { data?: { fileUrl?: string } },
      TransactionTableFilterParams | void
    >({
      query: (params) => ({
        url: `/${API.GET_TRANSACTION}/download`,
        method: "GET",
        params: getFormattedParams(params ?? {}),
      }),
      async onQueryStarted(_arg, { queryFulfilled }) {
        try {
          const result = await queryFulfilled;
          const fileUrl = (result.data?.data as Record<string, unknown>)?.fileUrl;
          if (typeof fileUrl === "string") {
            window.open(fileUrl, "_blank");
          }
        } catch (error) {
          console.error("Failed to download transaction report:", error);
        }
      },
    }),
  }),
});

export const {
  useGetTransactionsQuery,
  useDownloadTransactionReportMutation,
} = transactionApi;
